import { ApiService } from './../../core/services/api.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifyService } from '../../core/services/notify.service';
import { ActionModalComponent } from '../../shared/components/action-modal/action-modal.component';
import { PermissionService } from '../../core/services/permission.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  user: any;
  localUser: any;
  isLoading = false;
  
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ProfileComponent>,
    private apiService: ApiService,
    private notifyService: NotifyService,
    public permissions: PermissionService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.isLoading = true;

    let id: string | null = null;

    if (typeof this.data === 'string' && this.data.trim()) {
      id = this.data.trim();
    }


    if (!id) {
      this.localUser = localStorage.getItem('user');
      this.user = JSON.parse(this.localUser);
      this.apiService.getUser(this.user.userId).subscribe(
        (response: any) => {
          this.user = response.data;
          this.isLoading = false;
        },
        (error: any) => {
          this.notifyService.notifyErrorMessage('Error fetching user:', error);
          this.isLoading = false;
        }
      );
    }
    else {
      this.user = this.data
      this.apiService.getUser(id).subscribe(
        (response: any) => {
          this.user = response.data;
          this.isLoading = false;
        },
        (error: any) => {
          this.notifyService.notifyErrorMessage('Error fetching user:', error);
          this.isLoading = false;
        }
      );
    }
  }

  activateUser() {
    if (!this.user) return;
    const dlg = this.dialog.open(ActionModalComponent, {
      width: '520px',
      data: { title: this.user.name, mode: 'activate', payload: this.user.id },
    });
    dlg.afterClosed().subscribe(() => {
      this.apiService.activateUser(this.user.id).subscribe(
        () => {
          this.notifyService.notifySuccessMessage('Application activated successfully');
          this.closeDialog();
        },
      );
    });

  }


  suspendUser() {
    if (!this.user) return;
    const dlg = this.dialog.open(ActionModalComponent, {
      width: '520px',
      data: { title: this.user.name, mode: 'suspend', payload: this.user.id },
    });
    dlg.afterClosed().subscribe(() => {
      this.apiService.suspendUser(this.user).subscribe(
        () => {
          this.notifyService.notifySuccessMessage('Application suspended successfully');
          this.closeDialog();
        },
      );
    });


  }

  deactivateUser() {
    if (!this.user) return;
    const dlg = this.dialog.open(ActionModalComponent, {
      width: '520px',
      data: { title: this.user.name, mode: 'deactivate', payload: this.user.id },
    });
    dlg.afterClosed().subscribe(() => {
      this.apiService.deactivateUser(this.user).subscribe(
        () => {
          this.notifyService.notifySuccessMessage('Application deactivated successfully');
          this.closeDialog();
        },
      );
    });

  }

  closeDialog() {
    this.dialogRef.close();
  }
}
